<template>
  <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
    <div class="boxShadow setBorderRadius heig-frame-equipment-group">
      <b-row no-gutters>
        <b-col md="12" class="heig-frame-child">
          <gofix-card class="mb-0 heig-frame-child" fullContent>
            <gofix-default-table :settings="tableConfig"
                :table-items="tableItems"
                @new-item="newItem"
                @load-items="getTableData"
                ref="gofixTable">
            </gofix-default-table>
          </gofix-card>
        </b-col>
      </b-row>
    </div>

    <b-modal :no-close-on-backdrop="true" id="modal-create-orders" title="Add New Property" hide-footer :centered="true" v-model="modals.create.open" ref="modal-create-orders">
      <b-form class="formV2 formNLTProperty">
        <b-row align-v="center" class="mb-26">
          <b-col md="8">
            <gofix-form-input-number
              label="Enter 6-digit Postal Code"
              class="mb-0"
              required
              show-icon-required
              :decimalLimit="0"
              :allowDecimal="false"
              thousandsSeparatorSymbol=""
              :integerLimit="6"
              v-model="modals.create.data.postal_code">
            </gofix-form-input-number>
          </b-col>
          <b-col md="4">
            <gofix-button label="Check" :disabled="modals.create.isCheckLoading || (!modals.create.data.postal_code || modals.create.data.postal_code.length < 6)" :loading="modals.create.isCheckLoading" @click="checkExistingPostalCode"></gofix-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <gofix-form-dropdown 
              vLabel="name"
              label="Select Parent Node" 
              required
              show-icon-required
              :filterable="false" 
              :disabled="modals.create.isSave"
              :clearable="!modals.create.isSave"
              :options="modals.options.properties" 
              v-model="modals.create.data.parent" 
              @search="searchProperty"
              ref="parentNode">
            </gofix-form-dropdown>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <gofix-form-input 
              label="Enter Block Number/House Number"
              required
              show-icon-required
              :maxlength="6"
              :disabled="modals.create.isSave"  
              v-model="modals.create.data.street_no">
            </gofix-form-input>
          </b-col>
          <b-col md="12">
            <gofix-form-input 
              label="Enter Street Name"
              required
              show-icon-required
              :disabled="modals.create.isSave"  
              v-model="modals.create.data.street_name">
            </gofix-form-input>
          </b-col>
          <b-col md="12">
            <gofix-form-dropdown
              label="Select Property Type"
              vLabel="reference_value_text"
              required
              show-icon-required
              :disabled="modals.create.isSave" 
              :clearable="!modals.create.isSave"
              v-model="modals.create.data.property_type"
              :options="modals.options.property_types">
            </gofix-form-dropdown>
          </b-col>
        </b-row>
      </b-form>
      <b-button-group class="d-block text-right pr-4">
          <gofix-button label="SUBMIT" @click="showModalConfirm" :disabled="modals.create.isSave || (!modals.create.data.parent || !modals.create.data.street_no || !modals.create.data.street_name || !modals.create.data.property_type)" noBorder></gofix-button>
      </b-button-group>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.confirm.open">
      <div class="center">
        Property amendment is not allowed after submission. Are you sure all the details are correct?
      </div>
      <b-button-group class="btn-group">
        <b-button class="custom-btn" @click="modals.confirm.open = false">Cancel</b-button>
        <b-button class="custom-btn" @click="save" :disabled="modals.confirm.loading">
            <b-spinner v-if="modals.confirm.loading" small type="grow"></b-spinner>Confirm
        </b-button>
      </b-button-group>
    </b-modal>
  </div>
</template>
<script>
import { filters } from '@/_filterVar.js'
import { mapGetters } from 'vuex';

export default {
  name: 'nlt-properties',
  data() {
    let filter =  JSON.parse(JSON.stringify(filters['nlt_property']));
    return {
      tableConfig:{
        name: 'nlt-property',
        controls:{
          delete: false,
          create: this.$checkRole(this.$accessModule.nlt_property, 'create'),
          tableImport: false,
          tableExport: false
        },
        filter: filter,
        page: 1,
        limit: 100,
        total: 0,
        useDatabaseView: false,
        sortColumn: "id",
        sortDirection: "desc",
      },
      tableItems:[],
      modals:{
        options: {
          properties: [],
          property_types: []
        },
        create:{
          open: false,
          isSave: false,
          isCheckLoading: false,
          data: {
            street_name: null,
            street_no: null,
            property_type: null,
            postal_code: null,
            parent: null,
            contract_id: null
          }
        },
        confirm: {
          open: false,
          loading: false
        }
      },
      timer: {
        properties: null,
        check: null,
        save: null
      }
    }
  },
  computed: {
    ...mapGetters({
      ClientContractID: 'ContractController/ClientContractID',
    })
  },
  watch: {
    ClientContractID: function() {
      this.$refs.gofixTable.reloadTableItems();
    }
  },
  created () {
  },
  methods: {
    async getTableData(callback){
      const { tableRequest , resolve,reject } = await callback();
      tableRequest.filter.property_root_id.value = null
      if(this.ClientContractID && this.ClientContractID.property_root_id) tableRequest.filter.property_root_id.value = this.ClientContractID.property_root_id
      await this.$store.dispatch("PropertyController/getListNLTProperties", tableRequest)
          .then(response => {
            this.tableItems = response.items;
            this.tableConfig.total = response.total;
            resolve(response);
          })
          .catch(err => {
            this.$alertNotification("Can not load the data", "danger");
            reject();
          })
    },
    async newItem() {
      if(!this.ClientContractID || !this.ClientContractID.id) {
        return this.$alertNotification("Please select contract selector", "danger");
      }

      this.modals.create.isSave = true
      this.modals.create.data = Object.assign(this.modals.create.data, {
        street_name: null,
        street_no: null,
        property_type: null,
        postal_code: null,
        parent: null,
        contract_id: this.ClientContractID.id
      });

      this.searchProperty('', () => {})
      await this.getReferences()
      this.modals.create.open = true
    },
    async getReferences() {
      await this.$store.dispatch(`PropertyController/getReferences`, {
        filter: { reference_type: 'Property Type' },
        limit: -1,
        isCMS: true
      })
      .then(response => {
        this.modals.options.property_types = response.data.data.items;

        const uniqueData = [];
        const uniqueValues = new Set();

        response.data.data.items.forEach(item => {
          if (!uniqueValues.has(item.reference_value_text)) {
            uniqueValues.add(item.reference_value_text);
            uniqueData.push(item);
          }
        });

        this.modals.options.property_types = uniqueData
      })
    },
    searchProperty(search, loading) {
      this.modals.options.properties = []
      loading(true);
      if (this.timer.properties) {
          clearTimeout(this.timer.properties);
          this.timer.properties = null;
      }
      this.timer.properties = setTimeout(() => {
        this.$store.dispatch('PropertyController/getSearchProperties', {
            keyword: search,
            property_root_id: this.ClientContractID.property_root_id,
            parent_id: this.ClientContractID.property_root_id,
            limit: 100,
          })
          .then(response => {
            this.modals.options.properties = response
            loading(false);
          })
          .catch(err => {
            loading(false);
          })
      }, 500);
    },
    checkExistingPostalCode() {
      // if(!this.modals.create.data.parent) {
      //   return this.$alertNotification("Parent node is required", "danger");
      // }

      if(!this.modals.create.data.postal_code) {
        return this.$alertNotification("Postal code is required", "danger");
      }

      if (this.timer.check) {
        clearTimeout(this.timer.check);
        this.timer.check = null;
      }
      this.timer.check = setTimeout(() => {
        if(this.modals.create.isCheckLoading) return
        this.modals.create.isCheckLoading = true

        let params = {
          postal_code: this.modals.create.data.postal_code,
          // parent_id: this.modals.create.data.parent.id,
        }

        this.$store.dispatch('PropertyController/checkExistingPostalCode', params)
        .then(response => {
          this.modals.create.isCheckLoading = false
          this.modals.create.data.parent = this.modals.create.data.street_no = this.modals.create.data.street_name = this.modals.create.data.property_type = null
          if(response.data.data.existing) {
            this.modals.create.isSave = true
            if(response.data.data.property) {
              const property = response.data.data.property
              this.modals.create.data.property_type = property.property_type
              this.modals.create.data.parent = property.parent

              if(property.get_address) {
                if(property.get_address.street_no) {
                  this.modals.create.data.street_no = property.get_address.street_no
                }
                if(property.get_address.street_name) {
                  this.modals.create.data.street_name = property.get_address.street_name
                }
              }

              if(!this.modals.create.data.street_no || !this.modals.create.data.street_name) {
                const arrTmp = property.name.split(' ');
                if(arrTmp.length > 1) {
                  if(!this.modals.create.data.street_no) this.modals.create.data.street_no   = arrTmp[0].replace(',', '');
                  if(!this.modals.create.data.street_name) this.modals.create.data.street_name = arrTmp[1].replace(',', '');
                }
              }
              
            }
          } else {
            this.modals.create.isSave = false
          }
        })
        .catch(err => {
          this.modals.create.isCheckLoading = false
        })
      }, 200);

    },
    showModalConfirm() {
      if(!this.modals.create.data.parent) {
        return this.$alertNotification("Parent node is required", "danger");
      }
      if(!this.modals.create.data.street_no) {
        return this.$alertNotification("Block Number/House Number is required", "danger");
      }
      if(!this.modals.create.data.street_name) {
        return this.$alertNotification("Street name is required", "danger");
      }
      if(!this.modals.create.data.property_type) {
        return this.$alertNotification("Property type is required", "danger");
      }

      let pattern = /^[a-zA-Z0-9]+$/;
      let result = pattern.test(this.modals.create.data.street_no);
      if(!result) {
        return this.$alertNotification("Block Number/House Number must contain only letters and numbers", "danger");
      }

      this.modals.confirm.open = true
    },
    save() {
      if (this.timer.save) {
        clearTimeout(this.timer.save);
        this.timer.save = null;
      }
      this.timer.save = setTimeout(() => {
        if(this.modals.confirm.loading) return
        this.modals.confirm.loading = true

        let params = {
          name: `${this.modals.create.data.street_no} ${this.modals.create.data.street_name}, ${this.modals.create.data.postal_code}`,
          street_name: this.modals.create.data.street_name,
          street_no: this.modals.create.data.street_no,
          property_type_id: this.modals.create.data.property_type.id,
          property_type_text: this.modals.create.data.property_type.reference_value_text,
          postal_code: this.modals.create.data.postal_code,
          parent_id: this.modals.create.data.parent.id,
          contract_id: this.modals.create.data.contract_id,
          type: 'Building',
          country: 'Singapore',
          is_active: true,
          // new fields to create root_path
          property_root_id: this.ClientContractID.property_root_id,
          name_parent: this.modals.create.data.parent.name,
          is_nlt_property: true
        }

        this.$store.dispatch('PropertyController/saveProperty', params)
        .then(response => {
          this.modals.confirm.loading = this.modals.confirm.open = this.modals.create.open = false
          this.$refs.gofixTable.reloadTableItems();
          this.$alertNotification(this.$notificationV2('adding', 'property'));
        })
        .catch(err => {
          this.modals.confirm.loading = false
        })
      }, 300);
    }
  }
}
</script>
<style lang="scss" scoped>
  #modal-create-orders {
    .formNLTProperty {
      .gofixInput {
        &.gofixInputDisable {
          background: #c2c2c240;
        }
      }
    }
  }
</style>
